import React from "react";
import { Container, Image } from "react-bootstrap";
import "./Difference.css";
import whatwedo from "../../../../Asset/what-we-do.png";
import howwedo from "../../../../Asset/how-we-do.png";
import why from "../../../../Asset/why-wo.png";

const Difference = () => {
  return (
    <>
      <section className="difference-section">
        <Container>
          <div className="top-text-difference">
            <h2>
              HOW WE MAKE A <span> DIFFERENCE</span>
            </h2>
          </div>
          <div className="row sec-4-row">
            <div className="col-xl-4 col-md-4 sec-4-col">
              <div className="sec-4-col-card">
                <div className="icons-sticky">
                  <Image src={whatwedo} />
                </div>
                <h3>What We Do</h3>
                <p>
                  We take pride in providing cutting-edge digital solutions that
                  make a significant impact. Our experience includes
                  collaborating with leading Fortune 500 firms, SMEs, and
                  startups to deliver value through technology, strategic
                  approaches and creativity.{" "}
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 sec-4-col">
              <div className="sec-4-col-card">
                <div className="icons-sticky">
                  <Image src={howwedo} />
                </div>
                <h3>How We Do</h3>
                <p>
                  We take a time tested Why-What-How approach. This method
                  involves grasping WHY a task is essential, determining WHAT
                  must be done, and outlining HOW to execute it effectively.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 sec-4-col mb-0">
              <div className="sec-4-col-card">
                <div className="icons-sticky">
                  <Image src={why} />
                </div>
                <h3>Why Codeffi?</h3>
                <p>
                  We meet client expectations, boost business value, and produce
                  outstanding outcomes using a proactive strategy, unwavering
                  dedication, and creative attitude.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Difference;
